<div class="timeline__header">
  @if (label()) {
    <span class="timeline__header_label">{{ label() }}</span>
  }
  <div class="timeline__header_content">
    <ng-content></ng-content>
  </div>
</div>
